/**
 * Checks if the given string input is null or empty (whitespace)
 * @param input input to be checked.
 * @returns True if the input is null or empty, false otherwise
 */
export const isEmptyOrNull = (
  input?: number | string | null
): input is null | undefined =>
  input === undefined || !input?.toString().trim();
